export default "__VITE_ASSET__8U3VkYHJ__"